export default class ContractorDetails {
  constructor({
    name = null,
    email = null,
    phone = null,
    helpDesk = null,
    bio = null,
    img = null,
    notes = null,
  } = {}) {
    this.name = name;
    this.email = email;
    this.phone = phone;
    this.helpDesk = helpDesk;
    this.bio = bio;
    this.img = img;
    this.notes = notes;
  }
}
